/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CancelLastJobCommand } from '../model'
// @ts-ignore
import type { CancelStartJobCommand } from '../model'
// @ts-ignore
import type { FinishJobCommand } from '../model'
// @ts-ignore
import type { JobAndYardBlockEquipmentAssignmentDto } from '../model'
// @ts-ignore
import type { StartJobCommand } from '../model'
// @ts-ignore
import type { UploadConfirmationSignatureCommand } from '../model'
/**
 * JobsApi - axios parameter creator
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CancelLastJobCommand} [cancelLastJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelLastJob: async (
      cancelLastJobCommand?: CancelLastJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/cancelLastJob`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        cancelLastJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CancelStartJobCommand} [cancelStartJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelStartJob: async (
      cancelStartJobCommand?: CancelStartJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/cancelStart`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        cancelStartJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {FinishJobCommand} [finishJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishJob: async (
      finishJobCommand?: FinishJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/finish`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        finishJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [equipmentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNextByEquipment: async (
      equipmentId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/getNextByEquipment`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (equipmentId !== undefined) {
        localVarQueryParameter['equipmentId'] = equipmentId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StartJobCommand} [startJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startJob: async (
      startJobCommand?: StartJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/start`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        startJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UploadConfirmationSignatureCommand} [uploadConfirmationSignatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSignatures: async (
      uploadConfirmationSignatureCommand?: UploadConfirmationSignatureCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Jobs/signature`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        uploadConfirmationSignatureCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * JobsApi - functional programming interface
 */
export const JobsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CancelLastJobCommand} [cancelLastJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelLastJob(
      cancelLastJobCommand?: CancelLastJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelLastJob(
        cancelLastJobCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.cancelLastJob']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CancelStartJobCommand} [cancelStartJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelStartJob(
      cancelStartJobCommand?: CancelStartJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelStartJob(
        cancelStartJobCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.cancelStartJob']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {FinishJobCommand} [finishJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async finishJob(
      finishJobCommand?: FinishJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.finishJob(finishJobCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.finishJob']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [equipmentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNextByEquipment(
      equipmentId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobAndYardBlockEquipmentAssignmentDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNextByEquipment(
        equipmentId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.getNextByEquipment']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StartJobCommand} [startJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async startJob(
      startJobCommand?: StartJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.startJob(startJobCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.startJob']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UploadConfirmationSignatureCommand} [uploadConfirmationSignatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadSignatures(
      uploadConfirmationSignatureCommand?: UploadConfirmationSignatureCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSignatures(
        uploadConfirmationSignatureCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['JobsApi.uploadSignatures']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * JobsApi - factory interface
 */
export const JobsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = JobsApiFp(configuration)
  return {
    /**
     *
     * @param {CancelLastJobCommand} [cancelLastJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelLastJob(
      cancelLastJobCommand?: CancelLastJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .cancelLastJob(cancelLastJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CancelStartJobCommand} [cancelStartJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelStartJob(
      cancelStartJobCommand?: CancelStartJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .cancelStartJob(cancelStartJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {FinishJobCommand} [finishJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishJob(
      finishJobCommand?: FinishJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .finishJob(finishJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [equipmentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNextByEquipment(
      equipmentId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<JobAndYardBlockEquipmentAssignmentDto> {
      return localVarFp
        .getNextByEquipment(equipmentId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StartJobCommand} [startJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startJob(
      startJobCommand?: StartJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp.startJob(startJobCommand, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UploadConfirmationSignatureCommand} [uploadConfirmationSignatureCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSignatures(
      uploadConfirmationSignatureCommand?: UploadConfirmationSignatureCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .uploadSignatures(uploadConfirmationSignatureCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * JobsApi - object-oriented interface
 */
export class JobsApi extends BaseAPI {
  /**
   *
   * @param {CancelLastJobCommand} [cancelLastJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public cancelLastJob(
    cancelLastJobCommand?: CancelLastJobCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return JobsApiFp(this.configuration)
      .cancelLastJob(cancelLastJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CancelStartJobCommand} [cancelStartJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public cancelStartJob(
    cancelStartJobCommand?: CancelStartJobCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return JobsApiFp(this.configuration)
      .cancelStartJob(cancelStartJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FinishJobCommand} [finishJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public finishJob(finishJobCommand?: FinishJobCommand, options?: RawAxiosRequestConfig) {
    return JobsApiFp(this.configuration)
      .finishJob(finishJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [equipmentId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getNextByEquipment(equipmentId?: number, options?: RawAxiosRequestConfig) {
    return JobsApiFp(this.configuration)
      .getNextByEquipment(equipmentId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StartJobCommand} [startJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public startJob(startJobCommand?: StartJobCommand, options?: RawAxiosRequestConfig) {
    return JobsApiFp(this.configuration)
      .startJob(startJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UploadConfirmationSignatureCommand} [uploadConfirmationSignatureCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public uploadSignatures(
    uploadConfirmationSignatureCommand?: UploadConfirmationSignatureCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return JobsApiFp(this.configuration)
      .uploadSignatures(uploadConfirmationSignatureCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
